import { listOfRoles } from "components/WithRoleAuthorization/WithRoleAuthorization";
import { notificationStatus } from "constants/notificationStatus"

export const yesOrNoOptions = [{id: "0", label: "NÃO", value: "no"}, {id: "1",label: "SIM", value: "yes"}];

export const getResult = (result:string) => {
  if(result){
      if (result === "consider_process_or_system_failure_possibly_blameless_error") 
      return {style: 'bg-[#8AA15C] w-[550px] h[46px] mr-1 rounded-2xl break-words font-semibold px-[16px] py-[8px]',
              description: "Considerar falha de processo ou sistema. Erro possivelmente sem culpa. Rever processos, documentos, treinamentos etc."}
      if (result === "consider_the_possibility_of_violation_recklessness_or_negligence") 
          return {style: 'bg-[#DF8D2C] min-w-[472px] h[29px] mr-1 rounded-[20px] font-semibold px-[16px] py-[8px]',
                  description: "Considerar possibilidade de violação, imprudência ou negligência"}
      if (result === "hold_the_individual_accountable") 
          return {style: "bg-[#C43B51] min-w-[223px] h[30px] mr-1 rounded-[20px] font-semibold px-[16px] py-[8px]",
                  description: "Responsabilizar o indivíduo"}
  }
}

export const canEdit = (
    { loggedInUserIsResponsible, isSameLocation, isSameSector, notificationStatusState }:
        { loggedInUserIsResponsible: boolean, isSameLocation: boolean, isSameSector: boolean, notificationStatusState: string }) => {
    if (notificationStatusState === notificationStatus[3].label) {
        return [
            listOfRoles.admin,
            listOfRoles.location_qa,
            listOfRoles.corporate_quality_board
        ]
    } else {
        return [
            ...(loggedInUserIsResponsible ? [listOfRoles.admin] : []),
            ...(isSameLocation && isSameSector && loggedInUserIsResponsible ? [listOfRoles.location_manager] : []),
            ...(isSameLocation && loggedInUserIsResponsible ? [listOfRoles.location_qa] : []),
        ]
    }
}